/**
 * report-step.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { DataType, ServerDataType } from "../../common/data/data-types";
import { AlgorithmStep, AlgorithmStepData } from "./algorithm-step";
import { IntakeStep, IntakeStepData } from "./intake-step";

interface ReportStepData extends AlgorithmStepData
{
  isActive : boolean;
  order? : number;
}

interface IntakeShim
{
  type : DataType;
  cardinality : number;
  allowsDuplicates : boolean;
}
const INTAKE_SHIM : IntakeShim = {
  type: "empty",
  cardinality: 1,
  allowsDuplicates: false
};

/**
 * A {@code ReportStep} provides information to a user without soliciting them
 * for any additional action. A {@code ReportStep} is used to report the results
 * of executing an algorithm.
 */
export class ReportStep extends AlgorithmStep
{
  /**
   * Is the {@link ReportStep} active?
   */
  public isActive : boolean;

  /**
   * Optional ordering value for the report.
   */
  public order : number;

  // TODO: temporary holding until we have a step cessor map. maybe move to
  // AlgorithmStep level metadata property?
  public predecessors? : AlgorithmStep[];

  /**
   * Construct a new {@link ReportStep}.
   *
   * @param data
   *        An object constructed from JSON.
   */
  constructor (data : ReportStepData)
  {
    super(data);
    this.isActive = data.isActive;
    this.order = data.order || Number.MAX_SAFE_INTEGER;
  }

  private intakeForm : IntakeStep;
  public asEmptyIntake () : IntakeStep
  {
    if (!this.intakeForm)
    {
      this.intakeForm = new IntakeStep(Object.assign({}, this, INTAKE_SHIM));
    }
    return this.intakeForm;
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/algorithms/structure/report-step.ts